import { usePage } from "@inertiajs/react"
import Button from "./Button"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid"
import { GamesIndexProps } from "@/types/types"

const plurals = {
  game: "games",
  event: "events",
  player: "players",
  puzzle: "puzzles",
} as const

const stripPageOne = (url: string | null) => {
  if (!url) return url

  const base =
    typeof window !== "undefined" ? window.location.origin : "http://localhost"
  const u = new URL(url, base)

  const pageParam = u.searchParams.get("page")

  if (pageParam === "1" || pageParam === "") {
    u.searchParams.delete("page")
  }

  return u.pathname + (u.search ? u.search : "")
}

const Pagination = ({
  type,
}: {
  type: "game" | "event" | "player" | "puzzle"
}) => {
  const pluralType = plurals[type]

  const { pagy, meta } = usePage<GamesIndexProps>().props
  const { page, pages, count } = pagy
  const perPage = meta.limit

  return (
    <div className="padding sticky right-0 bottom-[calc(max(env(safe-area-inset-bottom),14px)+50px)] left-0 flex flex-col justify-between gap-y-4 border-t border-gray-200 bg-white/50 py-4 backdrop-blur sm:flex-row sm:items-center xl:bottom-0">
      <p className="hidden text-center text-sm text-gray-700 sm:block">
        Showing{" "}
        <span className="font-semibold">{(page - 1) * perPage + 1}</span> to{" "}
        <span className="font-semibold">{Math.min(page * perPage, count)}</span>{" "}
        of <span className="font-semibold">{count}</span>{" "}
        {count === 1 ? type : pluralType}
      </p>

      <div className="flex justify-between gap-x-2">
        <div className="rounded-xl bg-white">
          <Button
            style="secondary"
            disabled={!meta.prev}
            href={stripPageOne(meta.prev_url)}
          >
            <ChevronLeftIcon className="-ml-2 h-5 w-5" />
            <span>Previous</span>
          </Button>
        </div>

        <div className="flex items-center justify-center text-center text-sm tracking-widest text-gray-400 sm:hidden">
          <span className="font-semibold text-gray-700">{page}</span>/
          <span className="font-semibold text-gray-700">{pages}</span>
        </div>

        <div className="rounded-xl bg-white">
          <Button style="secondary" disabled={!meta.next} href={meta.next_url}>
            <span>Next</span>
            <ChevronRightIcon className="-mr-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Pagination
